import { render } from "./AddNewContactsModal.vue?vue&type=template&id=ca97e898"
import script from "./AddNewContactsModal.vue?vue&type=script&lang=js"
export * from "./AddNewContactsModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__